import { render } from "./ModalNfseSettings.vue?vue&type=template&id=63cd8471"
import script from "./ModalNfseSettings.vue?vue&type=script&lang=js"
export * from "./ModalNfseSettings.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__